import { createAction } from 'redux-actions'

const SET_ADVENTURE_DATE = 'SET_ADVENTURE_DATE '
const setAdventureDate = createAction(SET_ADVENTURE_DATE)

function adventureDate(state = '', { type, payload }) {
  switch (type) {
    case SET_ADVENTURE_DATE:
      return payload
    default:
      return state
  }
}

const SET_AVAILABILITY = 'SET_AVAILABILITY '
const setAdventureAvailability = createAction(SET_AVAILABILITY)

function adventureAvailability(state = [], { type, payload }) {
  switch (type) {
    case SET_AVAILABILITY:
      return payload
    default:
      return state
  }
}

export {
  setAdventureDate,
  adventureDate,
  setAdventureAvailability,
  adventureAvailability,
}
